
import ProjectDisplay from '../components/ProjectDisplay.js';

function TicketShark() {
  const projectData = {
    name: 'Event Manager',
    tagline: 'Event ticketing agent.',
    status: 'Complete',
    version: 'v1.1.5',
    tech: ['React', 'Node.js', 'Express', 'MongoDB', 'Stripe', 'Docker'],
    overview:
      'An Agentic LLM that can sync with the users calendar or travel itinerary and recommend events likely to be enjoyed.',
    features: [
      'Agentic Capabilities',
      'Custom AI toolkit',
      'QR code generation and validation',
      'Secure payment processing',
    ],
    links: {
      live: 'https://ticketshark.app',
      github: '[Private]',
    },
  };

  return <ProjectDisplay projectData={projectData} />;
}

export default TicketShark;
